// Vuex user module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  agentsBelongsToUserlist: {
    records: [],
    total: 0,
  },
  agentsList: {
    records: [],
    total: 0,
  },
  callingAgentDetails: {
    details: {},
  },
};

const getters = {
  agentsList: state => state.agentsList,
  agentsBelongsToUserlist: state => state.agentsBelongsToUserlist,
  callingAgentDetails: state => state.callingAgentDetails,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
